import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Toolbar, Button, Icon, DialogActions, IconButton, AppBar, Dialog, DialogContent, Typography } from 'material-ui';
import ReactTable from "react-table";
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { TextFieldFormsy, CheckboxFormsy } from '@fuse';
import axios from 'axios';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";
import 'react-select/dist/react-select.css'
import { confirmAlert } from 'react-confirm-alert';
import CloseIcon from '@material-ui/icons/Close';


class pettyCashCategory extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            dialogEdit: false,
            categoryEdit: {}
        };

        // this.setSelectedJob = this.setSelectedJob.bind(this);

    }

    addCategory = (data) => {
        this.setState({ loading: true });
        //  axios.post('http://localhost:5009/pettyCash/addPettyCashCategory',data)
        axios.post(window.accountServer + '/pettyCash/addPettyCashCategory', data)
            .then(res => {
                if (res.data.status) {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    updateCategory = (data) => {
        this.setState({ loading: true });
        //  axios.post('http://localhost:5009/pettyCash/updatePettyCashCategory',data)
        axios.post(window.accountServer + '/pettyCash/updatePettyCashCategory', data)
            .then(res => {
                if (res.data.status) {
                    this.getCategory();
                    this.setState({ dialogEdit: false });
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCategory();
                    this.setState({ dialogEdit: false });
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    getCategory = () => {

        this.setState({ loading: true });
        var category = [];
        // axios.get('http://localhost:5009/pettyCash/getPettyCashCategory')
        axios.get(window.accountServer + '/pettyCash/getPettyCashCategory')
            .then(response => {

                this.setState({ categoryList: response.data });
                this.setState({ loading: false });
            })
    }

    activateCategory = (id) => {


        confirmAlert({
            title: 'Confirm to Activate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.activate(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    activate = (id) => {

        var category = [];
        // axios.post('http://localhost:5009/pettyCash/activatePettyCashCategory',{'id':id})
        axios.post(window.accountServer + '/pettyCash/activatePettyCashCategory', { 'id': id })
            .then(res => {
                if (res.data.status) {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    diactivateCategory = (id) => {


        confirmAlert({
            title: 'Confirm to Diactivate',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.diactivate(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    diactivate = (id) => {

        var category = [];
        // axios.post('http://localhost:5009/pettyCash/diactivatePettyCashCategory',{'id':id})
        axios.post(window.accountServer + '/pettyCash/diactivatePettyCashCategory', { 'id': id })
            .then(res => {
                if (res.data.status) {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.success(res.data.msg);
                }

                else {
                    this.getCategory();
                    this.setState({ loading: false });
                    this.props.alert.error(res.data.msg);
                }
            })
    }

    openDialogEdit = (data) => {

        this.setState({ categoryEdit: data });
        this.setState({ dialogEdit: true });
    }


    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="subtitle-margin subtitle-color w-full sm:w-1/4">
                            Petty Cash Category
                        </h2>
                    </Toolbar>
                    <Formsy
                        onValidSubmit={this.addCategory}
                    >
                        <div className="block p-20">
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="categoryCode"
                                    label="Category Code"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="categoryName"
                                    label="Category Name"
                                    required
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <TextFieldFormsy
                                    type="text"
                                    name="categoryDes"
                                    label="Description"
                                />
                            </div>
                            <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">

                                <CheckboxFormsy
                                    className=""
                                    name="isActive"
                                    value="true"
                                    label="Active"
                                />
                            </div>

                       <div className="w-full sm:w-1/2 md:w-1/5 p-8 inline-block">
                             <DialogActions className="justify-right p-20">
                            <Button
                                type="submit"
                                variant="raised"
                                color="secondary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                }}
                            >
                                Save
                          </Button>
                            <Button
                                type="reset"
                                variant="raised"
                                color="primary"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                }}
                            >
                                Clear
                          </Button>
                            <Button
                                variant="raised"
                                color="default"
                            >
                                Help
                          </Button>
                        </DialogActions>
                        </div>
                        </div>

                       

                    </Formsy>
 
                    <div class="flex h-auto mt-4">

<div class="w-full bg-white h-auto">
                    <ReactTable
                        className={classNames(classes.root, "-striped -highlight m-12 p-20 border-2 border-green-darkest")}
                        getTrProps={(state, rowInfo, column) => {
                            return {
                                className: "cursor-pointer",
                            }
                        }}
                        data={this.state.categoryList}
                        columns={[
                            {
                                Header: "Category Code",
                                accessor: "PETTY_CASH_CATEGORY_CODE",
                                filterable: true,
                                className: '',
                                width: 200,
                                Cell: ({ row, original }) => (
                                    <span>
                                        <span style={{

                                            color: original.STATUS == 1 ? '#57d500' : '#Ff0000',
                                            transition: 'all .3s ease'
                                        }}>
                                            &#x25cf;
                                        </span>
                                        {
                                            row.value == '' ? ' '
                                                : row.PETTY_CASH_CATEGORY_CODE
                                        }
                                    </span>
                                )
                            },
                            {
                                Header: "Category",
                                accessor: "PETTY_CASH_CATEGORY",
                                filterable: true,
                                className: "",
                            },
                            {
                                Header: "Actions",
                                width: 128,
                                Cell: row => (

                                    <div className="flex items-center w-8 h-8">
                                        {row.original.STATUS == 1 ? (
                                            <div className="flex items-center">
                                                <IconButton
                                                    title='Edit'
                                                    className={classes.smaller}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.openDialogEdit(row.original);
                                                    }}
                                                >
                                                    <Icon className='text-blue'>mode_edit</Icon>
                                                </IconButton>
                                                <IconButton
                                                    title='Diactivate'
                                                    className={classes.smaller}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.diactivateCategory(row.original.ID_PETTY_CASH_CATEGORY);
                                                    }}
                                                >
                                                                 <Icon className='text-green-light'>
                                                            check_circle
                                    </Icon>
                                                </IconButton>
                                            </div>
                                        )
                                            : (
                                                <div className="flex items-center">
                                                    <IconButton
                                                        title='Edit'
                                                        className={classes.smaller}
                                                        disabled
                                                    >
                                                        <Icon className=''>mode_edit</Icon>
                                                    </IconButton>
                                                    <IconButton
                                                        title='Activate'
                                                        className={classes.smaller}
                                                        onClick={(ev) => {
                                                            ev.stopPropagation();
                                                            this.activateCategory(row.original.ID_PETTY_CASH_CATEGORY);
                                                        }}
                                                    >
                                           
                                    <Icon className='text-red-light'>
                                                        cancel
                                    </Icon>
                                                    </IconButton>
                                                </div>
                                            )}
                                    </div>

                                )
                            }

                        ]}
                        defaultPageSize={10}
                        noDataText="No Petty Cash Categories found"
                    />

                    </div>
                    </div>

                    <Dialog className={classNames(classes.root, "z-10")} open={this.state.dialogEdit}>

                        <AppBar className="flex w-full h-50 app-bar-size" position="static">
                            <Toolbar className="flex w-full">
                                <Typography className="w-full" variant="subheading" color="inherit" fullWidth maxWidth="md">
                                    Edit Category
                                </Typography>
                                <IconButton className="" color="inherit" onClick={(e) => {
                                    this.setState({ dialogEdit: false });
                                }} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>

                        <Formsy
                            onValidSubmit={this.updateCategory}
                        >

                            <DialogContent className="p-24">


                                <div className="block p-20">
                                    <div className="w-full p-8 ">

                                        <TextFieldFormsy
                                            type="hidden"
                                            name="editId"
                                            value={this.state.categoryEdit.ID_PETTY_CASH_CATEGORY}
                                        />
                                        <TextFieldFormsy
                                            type="text"
                                            name="categoryCodeEdit"
                                            label="Category Code"
                                            value={this.state.categoryEdit.PETTY_CASH_CATEGORY_CODE}
                                        />
                                    </div>
                                    <div className="w-full p-8 ">

                                        <TextFieldFormsy
                                            type="text"
                                            name="categoryNameEdit"
                                            label="Category"
                                            value={this.state.categoryEdit.PETTY_CASH_CATEGORY}
                                        />
                                    </div>
                                    <div className="w-full p-8 ">

                                        <TextFieldFormsy
                                            type="text"
                                            name="categoryDesEdit"
                                            label="Description"
                                            value={this.state.categoryEdit.DESCRIPTION}
                                        />
                                    </div>
                                    <div className="w-full  p-8">

                                        <CheckboxFormsy
                                            className=""
                                            name="isActiveEdit"
                                            value="true"
                                            label="Active"
                                        />
                                    </div>

                                </div>


                            </DialogContent>
                            <DialogActions className="justify-right pl-16">
                                <Button
                                    type="submit"
                                    variant="raised"
                                    color="secondary"
                                    size="small"
                                >
                                    Update
                                </Button>                               
                                <Button
                                    variant="raised"
                                    color="default"
                                    size="small"
                                >
                                    Help
                                </Button>
                                <Button
                                    variant="raised"
                                    color="primary"
                                    size="small"
                                    onClick={(e) => {
                                        this.setState({ dialogEdit: false });
                                    }}
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Formsy>

                    </Dialog>

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        this.getCategory();
    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(pettyCashCategory))));


// WEBPACK FOOTER //
// ./src/main/content/accounting/pettyCash/pettyCashCategory.js